import clsx from 'clsx';
import * as React from 'react';
import { HTMLAttributes } from 'react';

export interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  outerPadding?: number;
  marginVertical?: number;
  vertical?: boolean;
}

/**
 * Линия для разделения различного контента
 *
 * [Ссылка на макет](https://www.figma.com/design/GA8mTdovVruI98nkpMCxvV/%D0%91%D0%B0%D0%B7%D0%BE%D0%B2%D1%8B%D0%B5-%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D1%8B?node-id=1-36&t=iIKGU2qpJ2koNMAI-4)
 */
export const Divider: React.FC<DividerProps> = ({ vertical, outerPadding = 16, marginVertical = 28, ...props }) => {
  const className = clsx('divider', vertical ? 'divider_vertical' : 'divider_horizontal', props.className);

  return vertical ? (
    <div
      {...props}
      className={className}
      style={{
        ...props.style,
        marginTop: marginVertical,
        marginBottom: marginVertical,
        marginLeft: outerPadding,
        marginRight: outerPadding,
      }}
    />
  ) : (
    <div
      {...props}
      className={className}
      style={{
        ...props.style,
        marginTop: marginVertical,
        marginBottom: marginVertical,
        marginLeft: -outerPadding,
        marginRight: -outerPadding,
        width: `calc(100% + ${outerPadding * 2}px)`,
      }}
    />
  );
};
